import { render } from "./CardsComp.vue?vue&type=template&id=4143ba1e&scoped=true"
import script from "./CardsComp.vue?vue&type=script&lang=js"
export * from "./CardsComp.vue?vue&type=script&lang=js"

import "./CardsComp.vue?vue&type=style&index=0&id=4143ba1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4143ba1e"]])

export default __exports__